import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress, Container } from '@mui/material';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import Hospitals from './pages/Hospitals/Hospitals';
import Devices from './pages/Devices/Devices';
import Equipment from './pages/Equipment/Equipment';
import Suppliers from './pages/Suppliers/Suppliers';
import Barriers from './pages/Barriers/Barriers';
import EquipmentBarriers from './pages/EquipmentBarriers/EquipmentBarriers';

import Users from './pages/Users/Users';
import AuditLogs from './pages/AuditLogs/AuditLogs';
import Alerts from './pages/Alerts/Alerts';
import Alarms from './pages/Alarms/Alarms';
import AssetTracking from './pages/AssetTracking/AssetTracking';
import PatientTracking from './pages/PatientTracking/PatientTracking';
import StaffTracking from './pages/StaffTracking/StaffTracking';
import ZoneManagement from './pages/ZoneManagement/ZoneManagement';
import InteractiveMaps from './pages/InteractiveMaps/InteractiveMaps';
import Analytics from './pages/Analytics/Analytics';
import Login from './pages/Login/Login';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import { useAuth } from './contexts/AuthContext';
import { useTokenRefresh } from './hooks/useTokenRefresh';

function App() {
  const { isAuthenticated, loading } = useAuth();
  useTokenRefresh(); // Auto-refresh tokens

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Routes>
      {!isAuthenticated ? (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      ) : (
        <Route path="*" element={
          <Box sx={{ display: 'flex' }}>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/login" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/hospitals" element={<Hospitals />} />
                <Route path="/devices" element={<Devices />} />
                <Route path="/equipment" element={<Equipment />} />
                <Route path="/suppliers" element={<Suppliers />} />
                <Route path="/barriers" element={<Barriers />} />
                <Route path="/equipment-barriers" element={<EquipmentBarriers />} />

                <Route path="/users" element={<Users />} />
                <Route path="/audit-logs" element={<AuditLogs />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/alarms" element={<Alarms />} />
                <Route path="/asset-tracking" element={<AssetTracking />} />
                <Route path="/patient-tracking" element={<PatientTracking />} />
                <Route path="/staff-tracking" element={<StaffTracking />} />
                <Route path="/zone-management" element={<ZoneManagement />} />
                <Route path="/interactive-maps" element={<InteractiveMaps />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          </Box>
        } />
      )}
    </Routes>
  );
}

export default App;